module.exports = __webpack_public_path__ + "img/city-taxi.0d3269a1.svg";